import hljs from "highlight.js";

export default (el: HTMLElement): void => {
  const targets: NodeListOf<HTMLElement> = el.querySelectorAll("code");
  targets.forEach((target: HTMLElement) => {
    hljs.highlightElement(target);
  });
};
